import { Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useMediaType } from 'technical/media/hooks';
import GraphEmptyState from 'ui/icons/graphEmptyState';

export const EmptyGraph = () => {
  const { t } = useTranslation();
  const { isMobile } = useMediaType();

  if (isMobile) {
    return (
      <Flex
        vertical
        align="center"
        justify="space-around"
        gap={22}
        style={{ padding: '50px' }}
      >
        <GraphEmptyState width={125} />
        <Typography.Text>
          {t('dataAnalysis.emptyGraph.helper.noParameter')}
        </Typography.Text>
      </Flex>
    );
  }

  return (
    <Flex vertical align="center" justify="center">
      <Flex vertical align="center" justify="space-around">
        <GraphEmptyState />
        <Typography.Text>
          {t('dataAnalysis.emptyGraph.helper.instruction')}
        </Typography.Text>
        <Flex gap={5}>
          <Typography.Text strong>1.</Typography.Text>
          <Typography.Text>
            {t('dataAnalysis.emptyGraph.helper.subInstruction1')}
          </Typography.Text>
        </Flex>
        <Flex gap={5}>
          <Typography.Text strong>2.</Typography.Text>
          <Typography.Text>
            {t('dataAnalysis.emptyGraph.helper.subInstruction2')}
          </Typography.Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
